import React from 'react';
import { Box, Drawer } from '@mui/material';
import PropTypes from 'prop-types';
import { styled, useTheme } from '@mui/material/styles';
import { isEqual } from 'lodash';

import useTimeStore from '../ZustandProvider';
import LocationComplexComponent from '../LocationComplexComponent';
import LocationMediumComponent from '../LocationMediumComponent';
import LocationSimpleComponent from '../LocationSimpleComponent';

const LocationMenu = props => {
  const { isMobile, isPublicMap, map, MapProps, userProps } = props;
  const { buttonSettings, locationSettings } = map.settingsAdvancedMap;

  const drawerWidth = useTimeStore(state => state.drawerWidth);
  const drawerWidthLeft =
    drawerWidth === 0 ? `${100 / 3 - 1 / 3}vw` : `${drawerWidth - drawerWidth / 100}vw`;
  const drawerWidthLocal = isMobile ? '100%' : drawerWidthLeft;
  const [featureProp, setFeatureProp] = React.useState({});
  const expandDrawerMobile = true;
  const heightLocal = isPublicMap ? 0 : '56px';

  const theme = useTheme();

  const DrawerHeader = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'center'
  }));

  document.getElementsByTagName('body')[0].onclick = () => {
    const property = JSON.parse(localStorage.getItem('Propperties'));
    if (!isEqual(property, featureProp) && property !== null) {
      setFeatureProp({ ...property });
    }
    localStorage.removeItem('Propperties');
  };

  return (
    <>
      <Drawer
        sx={{
          width: drawerWidthLocal,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidthLocal,
            boxSizing: 'border-box',
            height:
              isMobile === true && expandDrawerMobile !== true
                ? '50%'
                : `calc(100% - ${heightLocal})`,
            top: isMobile === true && expandDrawerMobile === false ? '50%' : heightLocal,
            bottom: 0,
            overflowY: 'auto'
          }
        }}
        variant="persistent"
        anchor={isMobile ? 'bottom' : 'left'}
        open
      >
        <DrawerHeader />
        <Box
          bgcolor="white"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: 'auto',
            overflowY: 'auto',
            overflowX: 'hidden'
          }}
        >
          {locationSettings.typeComponent === 'Simple' && (
            <LocationSimpleComponent
              MapProps={MapProps}
              isPublicMap={isPublicMap}
              isMobile={isMobile}
              locationSettings={locationSettings}
              userProps={userProps}
            />
          )}
          {locationSettings.typeComponent === 'MediumWith' ||
            (locationSettings.typeComponent === 'MediumWithout' && (
              <LocationMediumComponent
                MapProps={MapProps}
                isPublicMap={isPublicMap}
                isMobile={isMobile}
                buttonSettings={buttonSettings}
                locationSettings={locationSettings}
                userProps={userProps}
              />
            ))}
          {locationSettings.typeComponent === 'Complex' && (
            <LocationComplexComponent
              MapProps={MapProps}
              isPublicMap={isPublicMap}
              isMobile={isMobile}
              buttonSettings={buttonSettings}
              locationSettings={locationSettings}
              userProps={userProps}
            />
          )}
        </Box>
      </Drawer>
    </>
  );
};

export default LocationMenu;

LocationMenu.defaultProps = {
  isMobile: false,
  isPublicMap: false,
  map: {},
  MapProps: {},
  userProps: {}
};
LocationMenu.propTypes = {
  isMobile: PropTypes.bool,
  isPublicMap: PropTypes.bool,
  map: PropTypes.object,
  MapProps: PropTypes.object,
  userProps: PropTypes.object
};
